import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import { Stack } from "@mui/material";
import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { MediaType } from "stores/ApplicationFilters/Filters/MediaType";
import { useOptionRestriction } from "../BaseFilterComponents/useRestrictedOptions";
import { usePruneSelectedValues } from "../BaseFilterComponents/usePruneSelectedValues";

export const MediaTypesFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const { isValueAllowed: isAllowed } = useOptionRestriction({
        optionRestriction: props.optionRestriction,
        restrictedValues: props.restrictedValues,
    });

    usePruneSelectedValues({
        selectedValues: props.store.mediaTypes,
        setSelectedValues: (values) => props.store.setMediaTypes(values),
        isValueAllowed: isAllowed,
    });

    const options = [
        {
            id: "application-filters-media-type-calls",
            label: "Calls",
            value: MediaType.Audio,
        },
        {
            id: "application-filters-media-type-chats",
            label: "Chats",
            value: MediaType.ProcessedChat,
        },
    ];

    return (
        <Stack>
            {options.map((option) => {
                const allowed = isAllowed(option.value);
                return (
                    <FormControlLabel
                        key={option.id}
                        label={option.label}
                        control={
                            <Checkbox
                                id={option.id}
                                onChange={() => {
                                    if (!allowed) return;
                                    props.store.toggleMediaType(option.value);
                                }}
                                checked={props.store.mediaTypes.includes(
                                    option.value,
                                )}
                                disabled={!allowed}
                            />
                        }
                        sx={{ maxHeight: "28px" }}
                    />
                );
            })}
        </Stack>
    );
});
